import service from '@/utils/request'

// 登录信息
export function getCurrentUserInfo (data) {
  return service({
    url: '/api/system/baseInfo/getCurrentUserInfo',
    method: 'get',
    params: data
  })
}
// 获取各级首页列表
export function getIndexList (data) {
  return service({
    url: '/api/menu/getIndexList',
    method: 'get',
    params: data
  })
}
// 获取工作室列表
export function getStudioList (data) {
  return service({
    url: '/api/open/center/getProjectPage',
    method: 'get',
    params: data
  })
}
// 获取项目信息(包含阶段)
export function getProjectInfo (data) {
  return service({
    url: '/api/open/getProjectInfo',
    method: 'get',
    params: data
  })
}
// 项目主页项目周期信息
export function projectCycle (data) {
  return service({
    url: '/api/outline/projectCycle',
    method: 'get',
    params: data
  })
}
// 获取系统消息未读通知总数
export function getNoticesNum (data) {
  return service({
    url: '/api/notices/unread/amount',
    method: 'get',
    params: data
  })
}
// 获取消息未读通知总数
export function getMessageNum (data) {
  return service({
    url: '/api/address-books/messages/unread/amount',
    method: 'get',
    params: data
  })
}
// 清空登录信息
export function quit (data) {
  return service({
    url: '/api/newLogin/quit',
    method: 'get',
    params: data
  })
}
// 左侧菜单
export function getMenu (data) {
  return service({
    url: 'api/menu/getMenu',
    method: 'get',
    params: data
  })
}
// 登录用户信息
export function autoLoginByCASId (data) {
  return service({
    url: '/api/newLogin/auto',
    method: 'get',
    params: data
  })
}
// 获取当前用户所有角色
export function getUserRoles (data) {
  return service({
    url: '/api/system/userInfo/getUserRoles',
    method: 'get',
    params: data
  })
}
// 获取学科学段教材信息下拉列表
export function getSubjectOption (data) {
  return service({
    url: '/api/option/getSubjectOption',
    method: 'get',
    params: data
  })
}
// 获取层级, 学科, 班级
export function getConditions (data) {
  return service({
    url: '/api/option/conditions',
    method: 'get',
    params: data
  })
}
// 根据角色类型获取角色
export function getProjectRoles (data) {
  return service({
    url: '/api/option/getProjectRoles',
    method: 'get',
    params: data
  })
}
// 获取穿梭框选项
export function getSearchConfigs (data) {
  return service({
    url: '/api/option/getSearchConfigs',
    method: 'get',
    params: data
  })
}
// 获取项目内的班级
export function getClasses (data) {
  return service({
    url: '/api/option/getClasses',
    method: 'get',
    params: data
  })
}
// 项目内班级 (联动)
export function getclassesLinkage (data) {
  return service({
    url: '/api/option/classes',
    method: 'get',
    params: data
  })
}
// 登录接口
export function userLogin (data) {
  return service({
    url: '/api/newLogin',
    method: 'post',
     data
  })
}
// 获取项目内的学校
export function getSchools (data) {
  return service({
    url: '/api/option/getSchools',
    method: 'get',
    params: data
  })
}
// 获取学情
export function getOutline (data) {
  return service({
    url: '/api/outline/getOutline',
    method: 'get',
    params: data
  })
}

// 首页配置
export function studioIndexConfig (data) {
  return service({
    url: '/api/index/studioIndexConfig',
    method: 'get',
    params: data
  })
}
// 一级评论 列表
export function getPageComment (data) {
  return service({
    url: '/api/comment/getPageComment',
    method: 'post',
    params: data
  })
}
// 一级评论 发布
export function addComment (data) {
  return service({
    url: '/api/comment/addComment',
    method: 'post',
    params: data
  })
}
// put方式发布一级评论
export function addPutComment (data) {
  return service({
    url: '/api/comment/addPutComment',
    method: 'put',
    data
  })
}
// 一级评论 删除
export function delFirstComment (data) {
  return service({
    url: '/api/comment/delFirstComment',
    method: 'post',
    params: data
  })
}
// 2级评论 删除
export function delSecondComment (data) {
  return service({
    url: '/api/comment/delSecondComment',
    method: 'post',
    params: data
  })
}
// 2级评论 发布
export function addSecondComment (data) {
  return service({
    url: '/api/comment/addSecondComment',
    method: 'post',
    params: data
  })
}
// put方式发布二级评论
export function addPutSecondComment (data) {
  return service({
    url: '/api/comment/addPutSecondComment',
    method: 'put',
    data
  })
}
// 2级评论 列表
export function getPageSecondComment (data) {
  return service({
    url: '/api/comment/getPageSecondComment',
    method: 'post',
    params: data
  })
}
// 切换角色
export function switchUser (data) {
  return service({
    url: '/api/system/switchUser',
    method: 'get',
    params: data
  })
}
// 获取用户是否设置"不再提醒"
export function noticeConfig (data) {
  return service({
    url: '/api/notices/noticeConfig',
    method: 'get',
    params: data
  })
}
// 首页重要通知设置"不再提醒"
export function setConfig (data) {
  return service({
    url: '/api/notices/setConfig',
    method: 'put',
    params: data
  })
}
// 当前项目直播版本
export function getVersion (data) {
  return service({
    url: '/api/live/version',
    method: 'get',
    params: data
  })
}
// 获取项目内的学科
export function getSubjects (data) {
  return service({
    url: '/api/option/getSubjects',
    method: 'get',
    params: data
  })
}
// 项目内班级 (联动)
export function classesLD (data) {
  return service({
    url: '/api/option/classes',
    method: 'get',
    params: data
  })
}
// 返回切换角色列表 目前只返回 114:客服角色 3845:项目管理员 32:教师
export function getRoleList (data) {
  return service({
    url: '/api/open/center/getRoleList',
    method: 'get',
    params: data
  })
}


// 举报
export function reportSubmit (data) {
  return service({
    url: '/api/report/submit',
    method: 'POST',
    params: data
  })
}
export function hasReported (data) {
  return service({
    url: '/api/report/hasReported',
    method: 'GET',
    params: data
  })
}

// value=-1 sxType=范围 查询环境    value=0 sxType=范围   查维度
export function getChildSxInfo (data) {
  return service({
    url: '/api/ability/getChildSxInfo',
    method: 'get',
    params: data
  })
}
export function getCourseBaseConfig (data) {
  return service({
    url: '/api/projectConfigurations/course/getCourseBaseConfig',
    method: 'get',
    params: data
  })
}
// 返回个人中心显示信息
export function getCenterInfo(data) {
  return service({
    url: '/api/open/center/getCenterInfo',
    method: 'get',
    params: data
  })
}

// 判断网址是否生效
export function getUrlOpen(data) {
  return service({
    url: '/api/open/frontPage/getUrlOpen',
    method: 'get',
    params: data
  })
}

// 获取滑动验证码的图片
export function getImgSwipe (data) {
  return service({
    url: '/api/login/getImgSwipe',
    method: 'get',
    params: data
  })
}

// 提交验证滑动验证码结果，返回0失败，1成功，2超过规定次数需要刷新
export function rstImgSwipe (data) {
  return service({
    url: '/api/login/rstImgSwipe',
    method: 'post',
    data
  })
}


// 查询接口
export function queryInfo (data) {
  return service({
    url: '/api/mall/getMallDecryptInfo',
    method: 'get',
    params: data
  })
}
